import axios from "../axiosInstance";
import {
  FetchMyEmailNotificationsParams,
  FetchMyEmailNotificationsResponse,
} from "./types";

export const fetchMyEmailNotifications = async (
  params: FetchMyEmailNotificationsParams = {},
): Promise<FetchMyEmailNotificationsResponse> => {
  const response = await axios.get<FetchMyEmailNotificationsResponse>(
    "/api/private/my-email-notifications",
    { params },
  );
  return response.data;
};
